const Skeleton = ({ height = 20, width = '100%' }) => (
    <div
      className="twgold_skeleton"
      style={{ height, width }}
    />
  );
  
  export default Skeleton;
  